// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__keVgL","colMin":"styles_colMin__qwliv"};